import './App.css';
import DisplayCards from "./DisplayCards"

function App() {
  return (
    <div className="App">
      <main>
        <DisplayCards />
      </main>
    </div>
  );
}

export default App;
